import React from 'react';
import { Field } from 'formik';
import { Box } from 'lmc-ui-library';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_LABELS } from '../types';
import ChangeableTextField from 'shared/Profile/ChangeableTextField';
import { ContactsProps } from './types';
import ChangeableAddress from 'shared/Profile/ChangeableAddress';

import styles from '../profile.module.scss';

const Contacts: React.FC<ContactsProps> = ({ onChangeClick, addressValues, setFieldValue }) => {
  return (
    <Box title="Contacts" className={styles.box}>
      <Box.Content>
        <ChangeableAddress onChangeClick={onChangeClick} addressValues={addressValues} setFieldValue={setFieldValue} />

        <Field
          component={ChangeableTextField}
          name={FIELDS.EMAIL}
          title={FIELDS_LABELS.EMAIL}
          onChangeClick={onChangeClick(FIELDS.EMAIL)}
        />

        <Field
          variant={VARIANTS_TYPES.PHONE}
          component={ChangeableTextField}
          name={FIELDS.PHONE}
          title={FIELDS_LABELS.PHONE}
          onChangeClick={onChangeClick(FIELDS.PHONE)}
        />
      </Box.Content>
    </Box>
  );
};

export default Contacts;
